import React, { useState } from 'react'
import { InputGroup, Input, InputGroupAddon, InputGroupText, Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { useDebounce } from '../../../hook/debounce';
import Loader from '../../Loader/buttonLoad';
import { Check } from 'lucide-react';
import moment from 'moment';
import { copyToClipboard } from '../../../lib/copytoClipboard';
import { useToast } from '../../../hook/usetoast';
import { useMoveToStakeHistory } from '../redeem/api';
import { useNavigate } from 'react-router-dom';
import { Footer } from '../../../components/footer';

const SwapIncome = () => {
    const [page, setPage] = useState(0);
    const navigate = useNavigate()
    const [search, setSearch] = useState('')
    const debouncedText = useDebounce(search)
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [uniqueId, setUniqueId] = useState(false)
    const toast = useToast()

    const { data: swapHistoryList, isFetching } = useMoveToStakeHistory({
        page,
        size: rowsPerPage,
        type: "swap-to-master",
        search: debouncedText
    })

    const totalPages = Math.ceil(swapHistoryList?.count / rowsPerPage);
    const handlePageChange = (newPage) => {
        if (newPage >= 0 && newPage < totalPages) {
            setPage(newPage);
        }
    };

    const copyuserAddress = async data => {
        setUniqueId(data?._id)
        await copyToClipboard(data?.stakeId)
        toast.success("Copied Successfully")
        setTimeout(() => {
            setUniqueId(false)
        }, 300);
    }

    return (
        <div>
            <div className="mainContent">
                {(isFetching) && <Loader />}
                <div className="pageContent def-py-30">

                    <div className='container'>
                        <div className="appPagetitle d-flex g-10 align-items-center">
                            <button className='btn btnBack' onClick={() => navigate('/master-wallet')}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.16699 10H15.8337" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M4.16699 10L7.50033 13.3333" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M4.16699 10.0003L7.50033 6.66699" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                            <span>Swap Income</span>
                        </div>
                        <div className='row'>
                            <div className="col-lg-12">
                                <div className="appcard mb-4 px-0 pb-2 cardbg">
                                    <div className="cardHeader border-bottom-0 px-4 pb-0">
                                    <div>
                                        <div className="px-4 mb-3">
                                            <div className='row justify-content-between'>
                                                <div className="col-md-6 mb-2 mb-md-0 text-center text-md-left">
                                                    <div className='d-inline-flex g-8 align-items-center'>
                                                        <span className='fs-18 fw-400 text-white-60'>Show</span>
                                                        <div className='form-group mb-0 formInputs gradientBg'>
                                                            <select className='form-control' value={rowsPerPage} onChange={(e) => setRowsPerPage(e.target.value)}>
                                                                <option value="10">10</option>
                                                                <option value="30">30</option>
                                                                <option value="50">50</option>
                                                            </select>
                                                        </div>
                                                        <span className='fs-18 fw-400 text-white-60'>entries</span>
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-inline justify-content-md-end justify-content-center'>
                                                        <div className="formInputs form-group gradientBg">
                                                            <InputGroup>
                                                                <InputGroupAddon addonType="prepend" tag='div'>
                                                                    <InputGroupText className='pl-0'>
                                                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M2.25 7.5C2.25 8.18944 2.3858 8.87213 2.64963 9.50909C2.91347 10.146 3.30018 10.7248 3.78769 11.2123C4.2752 11.6998 4.85395 12.0865 5.49091 12.3504C6.12787 12.6142 6.81056 12.75 7.5 12.75C8.18944 12.75 8.87213 12.6142 9.50909 12.3504C10.146 12.0865 10.7248 11.6998 11.2123 11.2123C11.6998 10.7248 12.0865 10.146 12.3504 9.50909C12.6142 8.87213 12.75 8.18944 12.75 7.5C12.75 6.81056 12.6142 6.12787 12.3504 5.49091C12.0865 4.85395 11.6998 4.2752 11.2123 3.78769C10.7248 3.30018 10.146 2.91347 9.50909 2.64963C8.87213 2.3858 8.18944 2.25 7.5 2.25C6.81056 2.25 6.12787 2.3858 5.49091 2.64963C4.85395 2.91347 4.2752 3.30018 3.78769 3.78769C3.30018 4.2752 2.91347 4.85395 2.64963 5.49091C2.3858 6.12787 2.25 6.81056 2.25 7.5Z" stroke="white" strokeOpacity="0.6" strokeLinecap="round" strokeLinejoin="round" />
                                                                            <path d="M15.75 15.75L11.25 11.25" stroke="white" strokeOpacity="0.6" strokeLinecap="round" strokeLinejoin="round" />
                                                                        </svg>
                                                                    </InputGroupText>
                                                                </InputGroupAddon>
                                                                <Input type='text' placeholder='Search' onChange={(e) => setSearch(e.target.value)} />
                                                            </InputGroup>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='table-responsive mb-3'>
                                            <table className='table myapptable table-hover table-borderless mb-0'>
                                                <thead>
                                                    <tr>
                                                        <th className='pl-4'>Transaction ID</th>
                                                        <th className='text-nowrap'>From Redeem Wallet</th>
                                                        <th className='text-nowrap'>To Master Wallet</th>
                                                        <th className='text-right pr-4'>Date & Time</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {swapHistoryList?.count > 0 ? (swapHistoryList?.data?.map((i) =>
                                                        <tr key={i}>
                                                            <td className="pl-4">
                                                                <div className="d-flex g-8">
                                                                    <span>{i?.stakeId}</span>
                                                                    {uniqueId === i?._id ? (
                                                                        <Check size={20} color="#FCD535" cursor="not-allowed" />
                                                                    ) : (
                                                                        <button
                                                                            className="btn btnEmpty"
                                                                            onClick={() => copyuserAddress(i)}
                                                                            onKeyDown={(e) => e.key === 'Enter' && copyuserAddress(i)}
                                                                            style={{ cursor: 'pointer' }}
                                                                        >
                                                                            <img
                                                                                src={require('../../../assets/images/master-wallet/copyIcon.svg').default}
                                                                                alt="copy icon"
                                                                            />
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </td>
                                                            <td >{i?.amount}<span className="text-white-60"> TPL</span></td>
                                                            <td className='text-nowrap'>{i?.toAmount}<span className="text-white-60"> USDT</span></td>
                                                            <td className='text-right pr-4 text-nowrap'>{moment(i?.createdAt).format("DD/MM/YYYY | hh:mm A")}</td>
                                                        </tr>)) : (
                                                        <tr>
                                                            <td colSpan="5" className="text-center">No data found</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="px-4">
                                            <div className='row'>
                                                <div className='col-lg-12'>
                                                    <Pagination aria-label="Page navigation" className='customPagination'>
                                                        <PaginationItem disabled={page === 0}>
                                                            <PaginationLink previous href="#" onClick={() => handlePageChange(page - 1)} className='prevbtn'>
                                                                <i className='bi bi-arrow-left align-bottom'></i> Previous
                                                            </PaginationLink>
                                                        </PaginationItem>
                                                        <span className='number'>

                                                        {page < 3 ? (
                                                            Array.from({ length: Math.min(3, totalPages) }, (_, index) => (
                                                                <PaginationItem key={index} active={index === page} className={`${index === page ? 'customPagination active' : 'customPagination'}`}>
                                                                    <PaginationLink href="#" onClick={() => handlePageChange(index)}>
                                                                        {index + 1}
                                                                    </PaginationLink>
                                                                </PaginationItem>
                                                            ))
                                                        ) : (
                                                            <>
                                                                {page > 0 && (
                                                                    <PaginationItem key={0} className="customPagination">
                                                                        <PaginationLink href="#" onClick={() => handlePageChange(0)}>
                                                                            1
                                                                        </PaginationLink>
                                                                    </PaginationItem>
                                                                )}

                                                                {page > 1 && (
                                                                    <PaginationItem disabled>
                                                                        <PaginationLink href="#">...</PaginationLink>
                                                                    </PaginationItem>
                                                                )}

                                                                {Array.from({ length: 3 }, (_, index) => (
                                                                    <PaginationItem key={page - 1 + index} active={page - 1 + index === page} className={`${page - 1 + index === page ? 'customPagination active' : 'customPagination'}`}>
                                                                        <PaginationLink href="#" onClick={() => handlePageChange(page - 1 + index)}>
                                                                            {page - 1 + index + 1}
                                                                        </PaginationLink>
                                                                    </PaginationItem>
                                                                ))}

                                                                {page < totalPages - 2 && (
                                                                    <PaginationItem disabled>
                                                                        <PaginationLink href="#">...</PaginationLink>
                                                                    </PaginationItem>
                                                                )}

                                                                {page < totalPages - 1 && (
                                                                    <PaginationItem key={totalPages - 1} className="customPagination">
                                                                        <PaginationLink href="#" onClick={() => handlePageChange(totalPages - 1)}>
                                                                            {totalPages}
                                                                        </PaginationLink>
                                                                    </PaginationItem>
                                                                )}
                                                            </>
                                                        )}

                                                        </span>

                                                        <PaginationItem disabled={page === totalPages - 1}>
                                                            <PaginationLink next href="#" onClick={() => handlePageChange(page + 1)} className='nextbtn'>
                                                                Next <i className='bi bi-arrow-right align-bottom'></i>
                                                            </PaginationLink>
                                                        </PaginationItem>
                                                    </Pagination>
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </div>
    )
}

export default SwapIncome
